import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-fine.svg";
import * as styles from "./Icon.module.scss";

type WeatherFineProps = React.SVGProps<SVGSVGElement>;

export const WeatherFine = ({ className, ...props }: WeatherFineProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
